var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-expansion-panel",
    [
      _c(
        "v-expansion-panel-header",
        { staticClass: "accordion-header" },
        [
          _c(
            "v-row",
            {
              staticStyle: { "background-color": "#f2f2f2" },
              attrs: { "no-gutters": "" },
            },
            [
              _c(
                "v-col",
                {
                  staticClass: "col-indice",
                  attrs: { "align-self": "center" },
                },
                [
                  _c("p", { staticClass: "text-center" }, [
                    _vm._v(
                      " " + _vm._s(_vm.riga.innerRigaDistinta.posizRiga) + " "
                    ),
                  ]),
                ]
              ),
              _c(
                "v-col",
                { staticClass: "col-dati" },
                [
                  !_vm.riga.richiestaDiInserimento
                    ? [
                        _vm._v(" Componente: "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.riga.innerRigaDistinta.componente) +
                              " (" +
                              _vm._s(
                                _vm.riga.innerRigaDistinta.idComponenteBga
                              ) +
                              ")"
                          ),
                        ]),
                        _vm._v(
                          " - " +
                            _vm._s(
                              _vm.riga.innerRigaDistinta.coloreComponente
                            ) +
                            " (" +
                            _vm._s(
                              _vm.riga.innerRigaDistinta.idColoreComponenteBgf
                            ) +
                            ") - um: "
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.riga.innerRigaDistinta.unMisuraDiBa)
                          ),
                        ]),
                        _vm._v(", id: "),
                        _c("em", [
                          _vm._v(_vm._s(_vm.riga.innerRigaDistinta.idBgj)),
                        ]),
                        _vm._v(" - Utilizzo: "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.riga.innerRigaDistinta.utilizzo)),
                        ]),
                        _vm._v(" - Linea vendita: "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.riga.innerRigaDistinta.lineaVenditaDescrizione
                            ) +
                              " (" +
                              _vm._s(
                                _vm.riga.innerRigaDistinta.lineaVenditaCodice
                              ) +
                              ")"
                          ),
                        ]),
                      ]
                    : [
                        _c("strong", [_vm._v("NUOVA RIGA")]),
                        _vm._v(
                          " - Componente: " +
                            _vm._s(_vm.riga.innerRigaDistinta.idComponenteBga) +
                            " - Colore componente: " +
                            _vm._s(
                              _vm.riga.innerRigaDistinta.idColoreComponenteBgf
                            ) +
                            " - um: "
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.riga.innerRigaDistinta.unMisuraDiBa)
                          ),
                        ]),
                        _vm._v(" - Utilizzo: "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.riga.innerRigaDistinta.utilizzo)),
                        ]),
                      ],
                  _vm.variazioneDiValidazione._accettata
                    ? _c(
                        "div",
                        { staticStyle: { float: "right" } },
                        [
                          _c(
                            "v-icon",
                            { attrs: { size: "medium", color: "success" } },
                            [_vm._v("mdi-send")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-expansion-panel-content",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c("div", { staticStyle: { "margin-top": "10px" } }, [
                    _vm._v(_vm._s(_vm.riga.innerRigaDistinta.descri)),
                  ]),
                  _c("div", { staticClass: "variazione-container" }, [
                    _c(
                      "ul",
                      _vm._l(_vm.riga.quantitaPerTaglia, function (qta, index) {
                        return _c("li", { key: "li_" + index }, [
                          _c("div", [_vm._v(_vm._s(qta.desc))]),
                          _vm._v(
                            _vm._s((+qta.qta).toFixed(2).replace(".", ",")) +
                              " "
                          ),
                        ])
                      }),
                      0
                    ),
                  ]),
                  _vm._l(
                    _vm.variazioniDaProcessare,
                    function (variazione, index) {
                      return _c(
                        "div",
                        {
                          key: "var_" + index,
                          staticClass:
                            "variazione-container variazione-modifiche",
                        },
                        [
                          _c("div", [
                            _vm._v(
                              " Comunicazione #" +
                                _vm._s(variazione.indice) +
                                " del " +
                                _vm._s(
                                  _vm._f("formatDate")(
                                    variazione.dataComunicazione
                                  )
                                ) +
                                " da fornitore: " +
                                _vm._s(variazione.idFornitore) +
                                " "
                            ),
                          ]),
                          variazione.statoValidazione ==
                          _vm.StatoVariazione.RigaModificataDalFornitore
                            ? _c(
                                "ul",
                                _vm._l(
                                  _vm.riga.quantitaPerTaglia,
                                  function (qta, i2) {
                                    return _c(
                                      "li",
                                      {
                                        key: "li_" + variazione.indice + i2,
                                        class: {
                                          "red--text":
                                            variazione
                                              .quantitaPerTagliaPreComunicazione[
                                              qta.indice - 1
                                            ] !=
                                            variazione
                                              .quantitaPerTagliaComunicate[
                                              qta.indice - 1
                                            ],
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              (+variazione
                                                .quantitaPerTagliaComunicate[
                                                qta.indice - 1
                                              ])
                                                .toFixed(2)
                                                .replace(".", ",")
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                          variazione.statoValidazione ==
                          _vm.StatoVariazione.RigaModificataDalFornitore
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "row-button",
                                  attrs: {
                                    color: "primary",
                                    fab: "",
                                    "x-small": "",
                                    dark: "",
                                    absolute: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.applicaModifica(variazione)
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", [
                                    _vm._v("mdi-arrow-down-thick"),
                                  ]),
                                ],
                                1
                              )
                            : variazione.statoValidazione ==
                              _vm.StatoVariazione.RigaEliminataDalFornitore
                            ? [_vm._v(" Richiesta eliminazione riga ")]
                            : _vm._e(),
                          _vm.variazioneDiValidazione.statoValidazione ==
                          _vm.StatoVariazione.RigaEliminataDalFornitore
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "row-button",
                                  attrs: {
                                    color: "grey",
                                    fab: "",
                                    "x-small": "",
                                    dark: "",
                                    absolute: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.applicaCancellazione()
                                    },
                                  },
                                },
                                [_c("v-icon", [_vm._v("mdi-check")])],
                                1
                              )
                            : _vm.variazioneDiValidazione.statoValidazione ==
                              _vm.StatoVariazione.RigaEliminataDaBC
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "row-button",
                                  attrs: {
                                    color: "orange",
                                    fab: "",
                                    "x-small": "",
                                    dark: "",
                                    absolute: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.annullaCancellazione()
                                    },
                                  },
                                },
                                [_c("v-icon", [_vm._v("mdi-undo")])],
                                1
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    }
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "variazione-container variazione-validazione",
                    },
                    [
                      _vm.variazioneDiValidazione.statoValidazione ==
                        _vm.StatoVariazione.RigaModificataDaBC ||
                      _vm.variazioneDiValidazione.statoValidazione ==
                        _vm.StatoVariazione.RigaAggiuntaDaBC ||
                      _vm.variazioneDiValidazione.statoValidazione ==
                        _vm.StatoVariazione.RigaModificataDalFornitore ||
                      _vm.variazioneDiValidazione.statoValidazione ==
                        _vm.StatoVariazione.RigaAggiuntaDalFornitore
                        ? _c(
                            "ul",
                            _vm._l(
                              _vm.variazioneDiValidazione
                                .quantitaPerTagliaComunicate,
                              function (qta, i) {
                                return _c(
                                  "li",
                                  {
                                    key:
                                      "sum_" +
                                      _vm.riga.innerRigaDistinta.posizRiga +
                                      i,
                                  },
                                  [
                                    _vm.variazioneDiValidazione._accettata ||
                                    _vm.riga.richiestaDiInserimento
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              padding: "10px 0",
                                              "background-color":
                                                "#dffadf !important",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.variazioneDiValidazione
                                                    .quantitaPerTagliaComunicate[
                                                    i
                                                  ]
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _c("v-text-field", {
                                          staticStyle: {
                                            margin: "10px 0 -10px 0",
                                          },
                                          attrs: {
                                            "background-color":
                                              _vm.variazioneDiValidazione
                                                .quantitaPerTagliaPreComunicazione[
                                                i
                                              ] !=
                                              _vm.variazioneDiValidazione
                                                .quantitaPerTagliaComunicate[i]
                                                ? "blue lighten-4"
                                                : "",
                                            type: "number",
                                            min: "0",
                                          },
                                          model: {
                                            value:
                                              _vm.variazioneDiValidazione
                                                .quantitaPerTagliaComunicate[i],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.variazioneDiValidazione
                                                  .quantitaPerTagliaComunicate,
                                                i,
                                                _vm._n($$v)
                                              )
                                            },
                                            expression:
                                              "variazioneDiValidazione.quantitaPerTagliaComunicate[i]",
                                          },
                                        }),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          )
                        : _vm.variazioneDiValidazione.statoValidazione ==
                          _vm.StatoVariazione.RigaEliminataDaBC
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "variazione-validazione-eliminata orange lighten-4",
                            },
                            [
                              _vm._v(" Eliminazione riga accettata "),
                              !_vm.variazioneDiValidazione._accettata
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "row-button",
                                      attrs: {
                                        color: "success",
                                        fab: "",
                                        "x-small": "",
                                        dark: "",
                                        absolute: "",
                                      },
                                      on: { click: _vm.accettaVariazione },
                                    },
                                    [_c("v-icon", [_vm._v("mdi-check")])],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.variazioneDiValidazione.statoValidazione !=
                      _vm.StatoVariazione.RigaEliminataDalFornitore
                        ? _c(
                            "div",
                            [
                              !_vm.variazioneDiValidazione._accettata
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "row-button",
                                      attrs: {
                                        color: "success",
                                        fab: "",
                                        "x-small": "",
                                        dark: "",
                                        absolute: "",
                                      },
                                      on: { click: _vm.accettaVariazione },
                                    },
                                    [_c("v-icon", [_vm._v("mdi-check")])],
                                    1
                                  )
                                : _c(
                                    "v-btn",
                                    {
                                      staticClass: "row-button",
                                      attrs: {
                                        color: "orange",
                                        fab: "",
                                        "x-small": "",
                                        dark: "",
                                        absolute: "",
                                      },
                                      on: { click: _vm.annullaVariazione },
                                    },
                                    [_c("v-icon", [_vm._v("mdi-undo")])],
                                    1
                                  ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                2
              ),
              _c(
                "v-col",
                { attrs: { sm: "2", md: "1" } },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { "padding-bottom": "0px" },
                      attrs: { "fill-height": "", fluid: "" },
                    },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            row: "",
                            wrap: "",
                            "align-center": "",
                            "justify-center": "",
                          },
                        },
                        [
                          _vm.riga.variazioneGenerataDaValidazione
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    fab: "",
                                    dark: "",
                                    small: "",
                                    color: "orange",
                                    "data-test": "undo-variazione",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.undoVariazione()
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { dark: "" } }, [
                                    _vm._v("mdi-undo"),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.esistonoVariazioniDaMostrare()
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    fab: "",
                                    dark: "",
                                    small: "",
                                    color: _vm.contieneValidazioniCorrelate(
                                      _vm.riga
                                    )
                                      ? "purple"
                                      : "blue",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.riga.mostraCorrelate =
                                        !_vm.riga.mostraCorrelate
                                    },
                                  },
                                },
                                [
                                  _vm.riga.mostraCorrelate
                                    ? _c("v-icon", { attrs: { dark: "" } }, [
                                        _vm._v("mdi-layers-triple-outline"),
                                      ])
                                    : _c("v-icon", { attrs: { dark: "" } }, [
                                        _vm._v("mdi-layers-triple"),
                                      ]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.riga.mostraCorrelate
            ? _c(
                "v-row",
                { staticStyle: { width: "100%" } },
                [
                  _vm.esistonoVariazioniDaMostrare()
                    ? _c("ValidazioniMassive", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "riga-distinta": _vm.riga,
                          variazione: _vm.variazioneDiValidazione,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }